import { UseFormReturn } from "react-hook-form";

import { PaymentsSubscriptionCancelAttributes } from "~/api/Api";
import FormLabel from "~/components/login/formLabel/FormLabel";
import TextArea from "~/components/ui/textArea/TextArea";
import labels from "~/helpers/labels";

import NotificationBlock from "../../notificationBlock/NotificationBlock";
import Input from "../../ui/input/Input";
import type { FormValues } from "../WithSubscription";
import styles from "./styles.module.scss";

const allowedSymbols = {
  min: 15,
  max: 1000,
};

const cancelReasons: {
  label: string;
  value: NonNullable<PaymentsSubscriptionCancelAttributes["cancel_reason"]>;
}[] = [
  { label: "Technical issues", value: "technical_issues" },
  { label: "Too expensive", value: "too_expensive" },
  { label: "Switching to another product", value: "switching_to_another" },
  { label: "Shutting down the company", value: "shutting_down" },
  { label: "Too difficult to use", value: "too_complex" },
  { label: "Missing features I need", value: "lacks_features" },
  { label: "Other (please explain below)", value: "other" },
];

type ReasonToGoFormContentProps = {
  form: UseFormReturn<FormValues>;
  onSubmitFeedbackModal: (data: FormValues) => void;
  cancelError: string;
};

const ReasonToGoFormContent = ({
  form,
  onSubmitFeedbackModal,
  cancelError,
}: ReasonToGoFormContentProps) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = form;

  const selectedReason = watch("cancel_reason");
  const commentText = watch("cancel_comment") || "";

  return (
    <>
      <p className={styles.modalText}>{labels.BEFORE_YOU_GO_MESSAGE}</p>
      <form
        id="cancelationModalForm"
        onSubmit={handleSubmit(onSubmitFeedbackModal)}
      >
        {/*
         // @ts-expect-error TS2339 non-existing className */}
        <div className={styles.checkboxWrapper}>
          <FormLabel label={labels.CANCEL_REASON} />
          {cancelReasons.map((reason) => (
            <Input
              key={reason.value}
              type="radio"
              value={reason.value}
              radioLabel={reason.label}
              id={`reason-${reason.value}`}
              {...register("cancel_reason", { required: true })}
            />
          ))}
          <p className={styles.errorMessage}>
            {errors.cancel_reason && labels.PLEASE_SELECT_REASON}
          </p>
        </div>

        <div className={styles.modalSection}>
          <FormLabel
            label={
              selectedReason === cancelReasons[6].value
                ? "Comment"
                : "Comment (optional)"
            }
          />
          <TextArea
            ownProps={{
              minSymbolsLength: allowedSymbols.min,
              maxSymbolsLength: allowedSymbols.max,
              currentSymbolsLength: commentText.length,
              errorMessage:
                errors?.cancel_comment &&
                (errors?.cancel_comment?.message ||
                  labels.PLEASE_PROVIDE_REASON),
            }}
            minRows={10}
            placeholder={labels.ANYTHING_YOU_WANT_TO_SHARE}
            {...register("cancel_comment", {
              required:
                selectedReason === cancelReasons[6].value ? true : false,
              maxLength: {
                value: allowedSymbols.max,
                message: labels.MAX_CHARACTERS_ALLOWED(allowedSymbols.max),
              },
            })}
          />
          {cancelError && (
            <div className={styles.serverErrorWrapper}>
              <NotificationBlock type="danger" message={cancelError} />
            </div>
          )}
        </div>
        <button type="submit" style={{ display: "none" }}>
          Submit
        </button>
      </form>
    </>
  );
};

export default ReasonToGoFormContent;
